import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import api from '../../../services/api';

const Step10PhotoCapture = () => {
    const { mockUser, refreshUser } = useOutletContext();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    
    // Camera State
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [stream, setStream] = useState(null);
    const [capturedImage, setCapturedImage] = useState(null);
    const [isUploaded, setIsUploaded] = useState(false);
    
    // Timer State (Simulation)
    const [timer, setTimer] = useState(900); // 15 minutes in seconds

    // 1. Initial Data Load & Timer
    useEffect(() => {
        // Fetch existing data
        const init = async () => {
            try {
                const res = await api.get(`/mock-cuet/application-data?mockAppId=${mockUser.id}`);
                if (res.data.success && res.data.data.captured_photo) {
                    setCapturedImage(res.data.data.captured_photo);
                    setIsUploaded(true);
                }
            } catch (err) { console.error(err); }
        };
        init();

        // Start Timer
        const interval = setInterval(() => {
            setTimer(prev => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        // Start Camera
        startCamera();

        return () => {
            clearInterval(interval);
            stopCamera();
        };
    }, [mockUser.id]);

    // Camera Functions
    const startCamera = async () => {
        try {
            const mediaStream = await navigator.mediaDevices.getUserMedia({ video: true });
            setStream(mediaStream);
            if (videoRef.current) {
                videoRef.current.srcObject = mediaStream;
            }
        } catch (err) {
            console.error("Error accessing webcam:", err);
            // alert("Could not access webcam. Please allow permissions.");
        }
    };

    const stopCamera = () => {
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
        }
    };

    const handleCapture = () => {
        if (videoRef.current && canvasRef.current) {
            const context = canvasRef.current.getContext('2d');
            // Draw current video frame to canvas
            context.drawImage(videoRef.current, 0, 0, 310, 310);
            // Convert to Base64
            const dataUri = canvasRef.current.toDataURL('image/jpeg');
            setCapturedImage(dataUri);
            setIsUploaded(false); // Reset upload status if retaken
        }
    };

    const handleUpload = async () => {
        if (!capturedImage) return;
        setLoading(true);

        try {
            const res = await api.post('/mock-cuet/save-step', {
                mockAppId: mockUser.id,
                stepNumber: 10,
                stepData: { capturedImage },
                nextStepNumber: 11
            });

            if (res.data.success) {
                setIsUploaded(true);
                refreshUser(11);
                alert("Your captured image have been saved successfully.");
            }
        } catch (err) {
            alert("Error uploading image");
        } finally {
            setLoading(false);
        }
    };

    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m < 10 ? '0'+m : m}:${s < 10 ? '0'+s : s}`;
    };

    return (
        <div id="ctl00_ContentPlaceHolder1_pnlImageUpload">
            <div className="appstatus" style={{ paddingTop: '0px', marginTop: '0px' }}>
                
                {/* --- CAPTURE INTERFACE --- */}
                {!isUploaded ? (
                    <div id="DivImgcapture1">
                        <h4>लाइव फोटोग्राफ लें (Capture Photograph)</h4>
                        
                        <div className="row">
                            <div className="col-lg-9">
                                <strong>
                                    कृपया लाइव फोटोग्राफ लेने से पहले नीचे दिए गए निर्देशों को ध्यानपूर्वक पढ़ें :<br />
                                    Please read the following instructions carefully to capture the live photograph :
                                </strong>
                                <ol style={{fontSize:'13px', lineHeight:'1.6'}}>
                                    <li>Connect your webcam to the device used for filling the application form. The Live Camera box will display your live image.</li>
                                    <li>
                                        <b style={{ color: 'red' }}>हल्के रंग की पृष्ठभूमि, उचित रोशनी और 80% चेहरा (कानों सहित, बिना मास्क) स्पष्ट रूप से दिखाई दे यह सुनिश्चित करें।</b><br />
                                        <b style={{ color: 'red' }}>Ensure a light background, proper lighting, and 80% face visibility (including ears, no mask).</b>
                                    </li>
                                    <li>Click “Capture Photograph” to take the photo.</li>
                                    <li>If satisfied, <strong>click “Upload Photograph”</strong> to save it. If not, retake and upload again.</li>
                                </ol>
                            </div>
                            <div className="col-lg-3 text-center">
                                <p>
                                    <span style={{ color: 'Red', fontWeight: 'bold', fontSize:'20px' }}>
                                        {formatTime(timer)}
                                    </span>
                                </p>
                                {/* Static QR Code Placeholder */}
                                <div style={{width:'150px', height:'150px', background:'#eee', margin:'0 auto', display:'flex', alignItems:'center', justifyContent:'center', border:'1px solid #ccc'}}>
                                    QR Code
                                </div>
                            </div>
                        </div>

                        <div className="row" style={{marginTop:'20px'}}>
                            {/* Live Camera */}
                            <div className="col-lg-6 text-center">
                                <h5 className="text-center">लाइव कैमरा (Live Camera)</h5>
                                <div style={{ width: '310px', height: '310px', margin: '0 auto', border: '2px solid #0094c3', borderRadius: '10px', overflow:'hidden', background:'#000' }}>
                                    <video 
                                        ref={videoRef} 
                                        autoPlay 
                                        playsInline 
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                                    />
                                </div>
                                <br/>
                                <button className="btn btn-primary" onClick={handleCapture}>
                                    Capture Photograph
                                </button>
                            </div>

                            {/* Captured Preview */}
                            <div className="col-lg-6 text-center">
                                <h5 className="text-center">कैप्चर की गई तस्वीर (Captured Picture)</h5>
                                <div style={{ width: '310px', height: '310px', margin: '0 auto', marginBottom: '15px' }}>
                                    {capturedImage ? (
                                        <img 
                                            src={capturedImage} 
                                            alt="Captured" 
                                            className="img-rounded" 
                                            style={{ width: '100%', height: '100%', objectFit: 'cover', border: '2px solid #0094c3', borderRadius: '10px' }} 
                                        />
                                    ) : (
                                        <div style={{ width: '100%', height: '100%', background: '#f0f0f0', border: '2px dashed #ccc', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            No Image Captured
                                        </div>
                                    )}
                                </div>
                                <button 
                                    className="btn btn-primary" 
                                    disabled={!capturedImage || loading}
                                    onClick={handleUpload}
                                >
                                    {loading ? 'Uploading...' : 'Upload Photograph'}
                                </button>
                                
                                <button className="btn btn-warning" onClick={() => setCapturedImage(null)} style={{marginLeft:'10px'}}>
                                    <i className="fa fa-refresh"></i> Refresh
                                </button>
                            </div>
                        </div>
                    </div>
                ) : (
                    /* --- SUCCESS STATE (Hidden until uploaded) --- */
                    <div id="divUploadedImg">
                        <h4>लाइव फोटोग्राफ लें (Capture Photograph)</h4>
                        <div className="row">
                            <div className="col-sm-12 text-center">
                                <p style={{ fontSize: '15px', fontWeight: '600', margin: '10px 0px', color: 'maroon' }}>
                                    <span>Your photo has been captured successfully on {new Date().toLocaleDateString()} <br /> आपकी फोटो सफलता पूर्वक कैप्चर की गई है। </span>
                                </p>
                            </div>
                        </div>
                        <br />
                        <div className="row">
                            <div className="col-lg-4"></div>
                            <div className="col-lg-4 text-center">
                                <img 
                                    src={capturedImage} 
                                    alt="Final" 
                                    style={{ borderWidth: '0px', height: '200px', border: '2px solid #0094c3', borderRadius:'5px' }} 
                                />
                            </div>
                            <div className="col-lg-4"></div>
                        </div>
                        <div className="row" style={{marginTop:'20px'}}>
                             <div className="col-sm-12 text-center">
                                <button 
                                    className="btn btn-warning" 
                                    onClick={() => { setIsUploaded(false); startCamera(); }}
                                    style={{marginRight:'10px'}}
                                >
                                    Edit
                                </button>
                                <button 
                                    className="btn btn-warning" 
                                    onClick={() => navigate('/services/counselling/dashboard/upload-documents')}
                                >
                                    Proceed
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                
                {/* Hidden Canvas for capture processing */}
                <canvas ref={canvasRef} width="310" height="310" style={{ display: 'none' }}></canvas>

                <br /><br />
                {!isUploaded && (
                    <div className="text-center">
                        <button className="btn btn-warning" onClick={() => navigate('/services/counselling/dashboard/emergency-contact')}>
                            Back
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Step10PhotoCapture;